import { gql } from '@apollo/client'

export const getRandomDailyAction = gql`
  query GetRandomDailyAction {
    getRandomDailyAction
  }
`
